import Cookies from 'js-cookie';
import { defaultOptions } from 'primevue/config';

export default class {
    #configuration = Object.freeze(_.cloneDeep(window.frontendConfiguration));
    #I18n = null;
    #Application = null;

    constructor(I18n) {
        this.#I18n = I18n;
    }

    install(app, options) {
        this.#Application = app;

        const exposed = {
            get: this.get.bind(this),
            setLocale: this.setLocale.bind(this),
            getLocale: this.getLocale.bind(this)
        };

        /**
         * Example:
         * this.$root.$configuration
         */
        app.config.globalProperties.$configuration = exposed;

        /**
         * Example:
         * import { inject } from 'vue';
         *
         * const ConfigurationProvider = inject('ConfigurationProvider')
         */
        app.provide('ConfigurationProvider', exposed);

        if(import.meta.env.DEV) {
            console.log(this.#configuration);
        }
    }

    /**
     * @param {string} key Dot separated keychain
     * @param {any} def Default
     */
    get(key, def = undefined) {
        return _.get(this.#configuration, key, def);
    }

    getLocale() {
        return this.#I18n.mode === 'legacy' ? this.#I18n.global.locale : this.#I18n.global.locale.value;
    }

    /**
     *
     * @param {string} locale
     */
    async setLocale(locale) {
        if(!this.get('vueJs.localization.allowed').hasOwnProperty(locale)) {
            console.error(`Localization key "${locale}" is not allowed!`);
            return;
        }

        if(!this.#I18n.global.availableLocales.includes(locale)) {
            let prefix = this.#configuration.user ? 'authenticated' : 'guest';
            let Module = await import(`../localization/${prefix}/${locale}.js`);

            this.#I18n.global.setLocaleMessage(locale, Module.default);
        }

        if (this.#I18n.mode === 'legacy') {
            this.#I18n.global.locale = locale;
        }
        else {
            this.#I18n.global.locale.value = locale;
        }

        this.adjustPrimeVueLocalization(locale);

        Cookies.set(this.get('vueJs.localization.cookieName') ?? 'Accept-Language', locale, {
            expires: 400
        });
        document.documentElement.setAttribute('lang', locale);
    }

    adjustPrimeVueLocalization(language) {
        const base = (defaultOptions && defaultOptions.locale) ? defaultOptions.locale : {};
        const custom = this.#I18n.global.messages.value[language]?.primevue || {};

        this.#Application.config.globalProperties.$primevue.config.locale = { ...base, ...custom };
    }
};
